import { Icon, caret_up, caret_down } from '../../components/Icon/Icon';
import { useTranslation } from '../../i18n/i18n';
import { useState } from 'react';
import { UiContainer } from '../../state/ui';
import { ApiFeatureGroup, ApiFeatureSheet } from '../../types';
import './FeatureSheet.css';

export function formatValue(item: { value: string; presentationValue: string }): string {
	if (item.value === 'Y' && item.presentationValue === 'Y') {
		return '✔';
	} else if (item.value === 'N' && item.presentationValue === 'N') {
		return '❌';
	} else {
		return item.presentationValue;
	}
}

type FeatureSheetProps = { data: ApiFeatureSheet };
export const FeatureSheet = ({ data }: FeatureSheetProps): JSX.Element => {
	const t = useTranslation().product;
	const ui = UiContainer.useContainer();
	const { windowSize } = ui;

	if (!windowSize.width) return <></>;
	const mobileView = windowSize.width <= 820;

	return (
		<div className="feature-sheet">
			<h2 id="product-specifications">{t.specifications}</h2>
			{data.featureGroups.map((group, i) => (
				<FeatureGroup group={group} expanded={i === 0 && !mobileView} key={group.id} />
			))}
		</div>
	);
};

type FeatureGroupProps = {
	group: ApiFeatureGroup;
	expanded?: boolean;
};

const FeatureGroup = ({ group, expanded }: FeatureGroupProps): JSX.Element => {
	const [isExpanded, setIsExpanded] = useState(expanded ?? false);
	return (
		<div className="feature-group-wrapper">
			<div className="heading" onClick={() => setIsExpanded(!isExpanded)}>
				<h3>{group.name}</h3>
				<div className="caret-wrapper">
					<Icon shape={isExpanded ? caret_up : caret_down} />
				</div>
			</div>
			{isExpanded && (
				<div className="feature-group">
					{group.features.map((feature, i) => (
						<div className="feature-row" key={feature.name + i}>
							<p>{feature.name}</p>
							<p>{formatValue(feature.value)}</p>
						</div>
					))}
				</div>
			)}
		</div>
	);
};
